import React, { Component } from "react";
import "./FXPollsWidget.css";
import BigNumber from "bignumber.js";
import i18n from "i18next";
import { APIAddress } from "../lib/apiAddressEnum";
import DataLoader from "../lib/DataLoader";
import { FXPollChart } from "../Components/FXPolls/FXPollChart/FXPollChart";
import { getAvailableFXPoll, getTargetCcy, fxList } from "../lib/constants";
import { RateButton } from "../Components/FXPolls/RateButton";
import { formatValue } from "../lib/utils";
import Navbar from "../Components/Navbar";
import IconButton from "../Components/Button/IconButton";
import closeIcon from "../img/close.svg";
import CalendarWidget from "./CalendarWidget";
import axios from "axios";

export default class FXPollsWidget extends Component<any, any> {
  fxPolls: any;
  filter: any;
  filterlist: any;

  constructor(props: any) {
    super(props);
    this.filter = React.createRef();
    this.state = {
      token: this.props.token,
      lang: this.props.lang,
      fxpoll: {},
      ccy: "USDHKD",
      fxPollccy: "ALL",
      ccynm: "",
      filterList: this.getFXList("ALL"),
      key: "",
      selectedccy: 0
    };
  }

  componentDidMount = () => {
    this.props.history.push(
      "/fxpolls?lang=" + this.props.lang + "&cc=" + this.props.cc
    );
    this.props.widget(false);
    this.loadFXPoll(this.props);
    this.loadFXQuote(this.props);
    this.setState({ ccy: this.state.filterList[0].cd, ccynm: this.state.filterList[0].nm })
  };

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.lang !== this.props.lang) {
      this.props.history.push(
        "/fxpolls?lang=" + nextProps.lang + "&cc=" + nextProps.cc
      );

      this.setState({ lang: nextProps.lang }, () => {
        this.setState({ filterList: this.getFXList("ALL") }, () => {
          this.setState({ filterList: this.getfxList(this.state.key) }, () => {
            this.setState({ ccy: this.state.filterList[this.state.selectedccy].cd, ccynm: this.state.filterList[this.state.selectedccy].nm })
          })
        })
      });
    }
  }

  getFXList = (fx: string) => {
    let list = [];
    let fxpoll = getAvailableFXPoll(fx);

    for (let i = 0; i < fxList.length; i++) {
      let m: { nm: string; cd: string } = { nm: "", cd: "" };

      if (
        fx === "ALL" ||
        fxList[i].cd.indexOf(this.state.ccy) === 0 ||
        fxList[i].cd.indexOf(this.state.ccy) === 3
      ) {
        if (fxpoll.indexOf(fxList[i].cd) >= 0) {
          m.cd = fxList[i].cd;

          let ccy1 = m.cd.substring(0, 3);
          let ccy2 = m.cd.substring(3);

          m.nm =
            i18n.t(["News.FXPoll.Currency." + ccy1, "Common." + ccy1], "") +
            "/" +
            i18n.t(["News.FXPoll.Currency." + ccy2, "Common." + ccy2], "");
          list.push(m);

          if (fxList[i].cd === "USDCNH") {
            list.push({
              nm:
                i18n.t(["News.FXPoll.Currency.USD", "Common.USD"], "") +
                "/" +
                i18n.t(["News.FXPoll.Currency.CNY", "Common.CNY"], ""),
              cd: "USDCNY",
            });
          }
        }
      }
      // }
    }

    this.fxPolls = list;
    return list;
  };

  loadFXPoll(props: any) {
    let base_url = this.props.domain + "/bochkfxwidget/data/fxpoll?";

    let ccy = this.state.ccy


    let url =
      base_url +
      "fx=" +
      ccy +
      "&lang=" +
      this.props.lang +
      "&token=" +
      this.state.token +
      "&_=" +
      new Date().getTime();

    axios.get(url).then((res: any) => {
      if (res.data.data.fxpoll && res.data.data.fxpoll.length > 0) {
        let fxpoll = res.data.data.fxpoll[0];
        this.setState(
          {
            fxpoll: {
              ...this.state.fxpoll,
              data: [
                { period: "1M", v: fxpoll.v1M, p: fxpoll.p1M },
                { period: "3M", v: fxpoll.v3M, p: fxpoll.p3M },
                { period: "6M", v: fxpoll.v6M, p: fxpoll.p6M },
                { period: "1Y", v: fxpoll.v1Y, p: fxpoll.p1Y },
              ],
              hc: fxpoll.hc,
            },
          }
        );
      } else {
        this.setState({ fxpoll: [] });
      }
    });

    // const param = {
    //   token: props.token,
    //   fx: this.state.ccy,
    //   lang: props.lang,
    //   _: new Date().getTime(),
    // };

    // let address = APIAddress.fxPolls;
    // const raw = DataLoader(address, param);
    // raw.then((data) => {
    //   if (data.fxpoll && data.fxpoll.length > 0) {
    //     let fxpoll = data.fxpoll[0];
    //     this.setState({
    //       fxpoll: {
    //         ...this.state.fxpoll,
    //         data: [
    //           { period: "1M", v: fxpoll.v1M, p: fxpoll.p1M },
    //           { period: "3M", v: fxpoll.v3M, p: fxpoll.p3M },
    //           { period: "6M", v: fxpoll.v6M, p: fxpoll.p6M },
    //           { period: "1Y", v: fxpoll.v1Y, p: fxpoll.p1Y },
    //         ],
    //         hc: fxpoll.hc,
    //       },
    //     });
    //   } else {
    //     this.setState({ fxpoll: [] });
    //   }
    // });
  }

  loadFXQuote(props: any) {
    let base_url = this.props.domain + "/bochkfxwidget/data/quote?";

    let ccy = this.state.ccy
    if (ccy == "USDCNY") {
      ccy = "USDCNH"
    }

    let url =
      base_url +
      "fx=" +
      ccy +
      "&detail=0" +
      "&lang=" +
      this.props.lang +
      "&token=" +
      this.state.token +
      "&_=" +
      new Date().getTime();

    axios.get(url).then((res: any) => {
      if (res.data.data.quote && res.data.data.quote.length > 0) {
        this.setState(
          {
            fxpoll: {
              ...this.state.fxpoll,
              bd: res.data.data.quote[0].bd,
              as: res.data.data.quote[0].as,
            },
          }
        );
      } else {
        this.setState({ fxpoll: "" });
      }
    });

    // const param = {
    //   token: props.token,
    //   fx: this.state.ccy,
    //   detail: 0,
    //   lang: props.lang,
    //   _: new Date().getTime(),
    // };

    // let address = APIAddress.quote;
    // const raw = DataLoader(address, param);
    // raw.then((data) => {
    //   if (data.quote && data.quote.length > 0) {
    //     this.setState({
    //       fxpoll: {
    //         ...this.state.fxpoll,
    //         bd: data.quote[0].bd,
    //         as: data.quote[0].as,
    //       },
    //     });
    //   } else {
    //     this.setState({ fxpoll: "" });
    //   }
    // });
  }

  onCurrencyChange = (e: any) => {
    console.log(e.currentTarget.value)
    this.setState(
      {
        ccy: this.state.filterList[e.currentTarget.value].cd,
        ccynm: this.state.filterList[e.currentTarget.value].nm,
        selectedccy: e.currentTarget.value,
      },
      () => {
        this.loadFXPoll(this.props);
        this.loadFXQuote(this.props);
      }
    );
  };

  buyAction = (e: any) => {
    if (this.props.fx) {
      let ccy =
        this.props.fx.substring(0, 3) + "/" + this.props.fx.substring(3);
      //buyCurrency(ccy);
    }
  };

  sellAction = (e: any) => {
    if (this.props.fx) {
      let ccy =
        this.props.fx.substring(0, 3) + "/" + this.props.fx.substring(3);
      //sellCurrency(ccy);
    }
  };

  displayLabel(period: string) {
    switch (period) {
      case "1M":
        return i18n.t("News.FXPoll.1M", "");
      case "3M":
        return i18n.t("News.FXPoll.3M", "");
      case "6M":
        return i18n.t("News.FXPoll.6M", "");
      case "1Y":
        return i18n.t("News.FXPoll.1Y", "");
      default:
        return;
    }
  }

  displayValue(value: string, percent: number) {
    if (percent > 0) {
      return <span style={{ color: "#377D22" }}>+{value}</span>;
    } else if (percent < 0) {
      return <span style={{ color: "#B51A25" }}>{value}</span>;
    } else {
      return <span>{value}</span>;
    }
  }

  displayPercent(value: string, percent: any) {
    percent = new BigNumber(percent).decimalPlaces(2);
    let display = percent.toFixed(2) + "%";

    if (percent > 0) {
      return <span style={{ color: "#377D22" }}>+{display}</span>;
    } else if (percent < 0) {
      return <span style={{ color: "#B51A25" }}>{display}</span>;
    } else {
      return <span>{display}</span>;
    }
  }

  renderValue(value: any) {
    if (value) {
      return "$" + value;
    }
  }

  getfxList(searchccy: any) {
    let list = new Array();
    for (let i = 0; i < this.fxPolls.length; i++) {
      if (
        this.fxPolls[i].cd.indexOf(searchccy) > -1 ||
        this.fxPolls[i].nm.indexOf(searchccy) > -1
      ) {
        let m = { cd: "", nm: "" };
        m.cd = this.fxPolls[i].cd;
        m.nm = this.fxPolls[i].nm;
        list.push(m);
      }
    }

    return list;
  }

  onTextChange(e: React.FormEvent<HTMLInputElement>) {
    const filterList = this.getfxList(
      e.currentTarget.value.trim().toUpperCase()
    );

    if (e.currentTarget.value != "") {
      if (filterList.length > 0)
        this.setState(
          {
            key: e.currentTarget.value.trim().toUpperCase(),
            filterList: filterList,
            selectedccy: "0",
            ccy: filterList[0].cd,
            ccynm: filterList[0].nm,
          },
          () => {
            this.loadFXPoll(this.props);
            this.loadFXQuote(this.props);
          }
        );
      else
        this.setState({
          key: e.currentTarget.value.trim().toUpperCase(),
          filterList: filterList,
        });
    } else {
      this.setState(
        {
          key: e.currentTarget.value.trim().toUpperCase(),
          filterList: this.fxPolls,
          selectedccy: "0",
          ccy: filterList[0].cd,
          ccynm: filterList[0].nm,
        },
        () => {
          this.loadFXPoll(this.props);
          this.loadFXQuote(this.props);
        }
      );
    }
  }

  clearFilter = (e: any) => {
    this.filter.current.value = "";
    const filterList = this.getFXList("ALL");
    this.setState({
      key: "",
      filterList: this.fxPolls,
      selectedccy: "0",
      ccy: filterList[0].cd,
      ccynm: filterList[0].nm,
    });
  };

  renderClose() {
    if (this.state.key.length > 0)
      return (
        <IconButton
          onClick={this.clearFilter}
          style={{ width: "20px", height: "20px" }}
          img={<img width="100%" height="100%" src={closeIcon} alt=""></img>}
        ></IconButton>
      );
  }

  renderCNYRemark() {
    if (this.state.ccy === 'USDCNH') {
      return <div className='FXPollWidget-CNRemark'>{i18n.t('News.FXPoll.CNRemark', '')}</div>
    }
  }

  renderFXData() {
    return (
      <div>
        <div className="FXPollWidget-Table-Title" style={{ backgroundColor: "#e0e0e0" }}>
          {this.state.ccynm}
        </div>
        <div className="FXPollWidget-Content">
          <div className="FXPollWidget-Chart">
            <div className="FXPollWidget-Chart-Title">
              {i18n.t("News.FXPoll.Title", "")}
            </div>
            <div className="FXPollWidget-Chart-Content">
              {this.state.fxpoll !== undefined && (
                <FXPollChart
                  hc={this.state.fxpoll.hc}
                  data={this.state.fxpoll.data}
                />
              )}
            </div>
          </div>
          <div className="FXPollWidget-Table-Content">
            <div className="FXPollWidget-Table">
              <div className="FXPollWidget-Table-Row" >
                <div
                  className="FXPollWidget-Table-Row-Label"
                  style={{ borderBottom: "1px solid #E8E8E8", fontSize: "110%" }}
                >
                  {i18n.t("News.FXPoll.RWR", "")}
                </div>
                <div
                  className="FXPollWidget-Table-Row-Value"
                  style={{ borderBottom: "1px solid #E8E8E8" }}
                >
                  {this.state.fxpoll.hc}
                </div>
                <div
                  className="FXPollWidget-Table-Row-Percent"
                  style={{ borderBottom: "1px solid #E8E8E8" }}
                >
                  -
              </div>
              </div>

              <div className="FXPollWidget-Table-Row" style={{ backgroundColor: "#e0e0e0" }}>
                <div
                  className="FXPollWidget-Table-Row-Label"
                  style={{ borderBottom: "1px solid #E8E8E8" }}
                >

                </div>
                <div
                  className="FXPollWidget-Table-Row-Value"
                  style={{ borderBottom: "1px solid #E8E8E8", fontSize: "110%", fontWeight: 900 }}
                >
                  {i18n.t("News.FXPoll.TableTitle1", "")}
                </div>
                <div
                  className="FXPollWidget-Table-Row-Percent"
                  style={{ borderBottom: "1px solid #E8E8E8", fontSize: "110%", fontWeight: 900 }}
                >
                  {i18n.t("News.FXPoll.TableTitle2", "")}
                </div>
              </div><React.Fragment>
                {this.state.fxpoll.data !== undefined &&
                  this.state.fxpoll.data.map((item: any, idx: number) => (
                    <React.Fragment key={idx}>
                      <div className="FXPollWidget-Table-Row">
                        <div
                          className="FXPollWidget-Table-Row-Label"
                          style={
                            idx !== this.state.fxpoll.data.length - 1
                              ? { borderBottom: "1px solid #E8E8E8" }
                              : {}
                          }
                        >
                          {this.displayLabel(item.period)}
                        </div>
                        <div
                          className="FXPollWidget-Table-Row-Value"
                          style={
                            idx !== this.state.fxpoll.data.length - 1
                              ? { borderBottom: "1px solid #E8E8E8" }
                              : {}
                          }
                        >
                          {this.displayValue(item.v, item.p)}
                        </div>
                        <div
                          className="FXPollWidget-Table-Row-Percent"
                          style={
                            idx !== this.state.fxpoll.data.length - 1
                              ? { borderBottom: "1px solid #E8E8E8" }
                              : {}
                          }
                        >
                          {this.displayPercent(item.v, item.p)}
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
              </React.Fragment>
            </div>
            <div className="FXPollWidget-Remark">
              <div className="FXPollWidget-Remark-Title">
                {i18n.t("News.FXPoll.Remark.Title", "")}
              </div>
              <div className="FXPollWidget-Remark-Content">
                {i18n.t("News.FXPoll.Remark.Content", "")}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderBuySellButton() {
    if (
      this.state.fxpoll !== undefined &&
      this.state.fx !== "USDCNY" &&
      this.state.fx !== "USDCNH"
    ) {
      return (
        <div className="FXPollWidget-BuySell">
          <RateButton
            onclick={this.sellAction}
            style={{
              border: "1px solid #B12832",
              color: "#B12832",
              letterSpacing: "-0.36px",
              lineHeight: "15px",
              padding: "10px",
            }}
            label={
              i18n.t("Common.Sell", "") + " " + getTargetCcy(this.state.ccy)
            }
            value={
              <span style={{ fontSize: "110%", letterSpacing: "-0.39px" }}>
                {formatValue(this.state.fxpoll.bd, "", 0, "")}
              </span>
            }
          ></RateButton>
          <RateButton
            onclick={this.buyAction}
            style={{
              border: "1px solid #377D22",
              color: "#377D22",
              letterSpacing: "-0.36px",
              lineHeight: "15px",
              padding: "10px",
              marginLeft: "10px",
            }}
            label={
              i18n.t("Common.Buy", "") + " " + getTargetCcy(this.state.ccy)
            }
            value={
              <span style={{ fontSize: "100%", letterSpacing: "-0.39px" }}>
                {formatValue(this.state.fxpoll.as, "", 0, "")}
              </span>
            }
          ></RateButton>
        </div>
      );
    }
  }

  render() {
    return (
      <div style={{ fontSize: this.props.fontSize || "100%" }}>
        <Navbar lang={this.props.lang} cc={this.props.cc} />
        <div className="content">
          <div className="title">{i18n.t("FXPolls.Title2")}</div>
          <div className="header">
            <div className="fxFoll">
              <div className="fxFoll-select">
                <div className="fxFoll-title">
                  {i18n.t("Chart.MenuItem", "")}
                </div>
                <select
                  onChange={(e) => this.onCurrencyChange(e)}
                  value={this.state.selectedccy}
                  style={{
                    flex: 1.5,
                    marginLeft: "10px",
                    height: "25px",
                  }}
                >
                  {this.state.filterList.map((item: any, i: number) => {
                    return (
                      <option key={i} value={i}>
                        {item.nm}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="fxFoll-searchbox">
                <input
                  placeholder={i18n.t("Common.SearchCurrency", "")}
                  ref={this.filter}
                  onChange={(e) => this.onTextChange(e)}
                ></input>
                <div className="fxFoll-searchbox-clear">
                  {this.renderClose()}
                </div>
              </div>

            </div>

            {/* <div className="header-BuySell">{this.renderBuySellButton()}</div> */}
          </div>
          {this.renderCNYRemark()}
          {this.renderFXData()}
          <CalendarWidget
            domain={this.props.domain}
            lang={this.props.lang}
            fontSize={this.state.fontSize}
            token={this.props.token}
          // cc={this.cc}
          // {...props}
          />
        </div>
      </div>
    );
  }
}
